import Vue from 'vue';
import gridProps from '@/gridProps';

import {
  formatNumber,
  alignForNumber,
  addGroupingInResponseData,
  LinkCellRenderer,
  autoResize,
  ProgressBarByFieldsRenderer
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse,
} from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    salesContracts: [],
    columns: [],
    salesContractsCount: null,
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      components: {
        'BuyerLink': LinkCellRenderer('buyer', '/partners/'),
        'SellerLink': LinkCellRenderer('seller', '/partners/'),
        'PartnerContractLink': LinkCellRenderer('id', '/sales-contracts/', false),
        'ReadinessProgressBar': ProgressBarByFieldsRenderer('shipped_m3', 'ordered_m3')
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value, null);
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      }
    },
    gridName: ''
  },
  getters: {
    salesContracts(state) {
      return state.salesContracts;
    },
    columns(state) {
      return state.columns;
    },
    gridOptions(state) {
      return {...state.gridOptions, ...gridProps};
    },
    salesContractsCount(state) {
      return state.salesContractsCount
    }
  },
  mutations: {
    setData(state, payLoad) {
      if (payLoad.data) {
        state.salesContracts = addGroupingInResponseData(payLoad.data.results);
        state.salesContractsCount = payLoad.data.count;
      } else {
        state.salesContracts = payLoad;
      }
      state.columns = addColIdToColumns(payLoad.used_columns);
      state.gridName = payLoad.grid_name;
    }
  },
  actions: {
    loadSalesContracts(store, payload) {
      if (store.getters.gridOptions.api) {
        store.getters.gridOptions.api.showLoadingOverlay();
      }
      Vue.http.get('sales/search_for_sales_contracts/', {params: payload})
        .then(handlerResponse)
        .then(data => {
          store.commit('setData', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/sales/contracts/salesContracts.js